/* Moved from sections/hlth-contact.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var section = document.querySelector('.hlth-contact-' + SID + '');
        if (!section) return;
        var dropzone = section.querySelector('[data-hlth-dropzone]');
        var fileInput = section.querySelector('[data-hlth-file-input]');
        var fileList = section.querySelector('[data-hlth-file-list]');
        var fileData = section.querySelector('[data-hlth-file-data]');
        var entries = []; /* { file, name, size, dataUrl } */

        if (!dropzone || !fileInput) return;

        ['dragenter', 'dragover'].forEach(function(evt) {
          dropzone.addEventListener(evt, function(e) {
            e.preventDefault();
            dropzone.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function(evt) {
          dropzone.addEventListener(evt, function(e) {
            e.preventDefault();
            dropzone.classList.remove('is-dragover');
          });
        });
        dropzone.addEventListener('drop', function(e) {
          if (e.dataTransfer.files.length) addFiles(e.dataTransfer.files);
        });
        fileInput.addEventListener('change', function() {
          if (fileInput.files.length) {
            addFiles(fileInput.files);
            fileInput.value = '';
          }
        });

        function addFiles(newFiles) {
          for (var i = 0; i < newFiles.length; i++) {
            var f = newFiles[i];
            if (f.size > 1024 * 1024) { alert('File "' + f.name + '" exceeds 1 MB limit.'); continue; }
            readFile(f);
          }
        }

        function readFile(f) {
          var reader = new FileReader();
          reader.onload = function() {
            entries.push({ name: f.name, size: f.size, dataUrl: reader.result });
            renderList();
            syncHidden();
          };
          reader.readAsDataURL(f);
        }

        function removeFile(index) {
          entries.splice(index, 1);
          renderList();
          syncHidden();
        }

        function renderList() {
          fileList.innerHTML = '';
          entries.forEach(function(e, i) {
            var el = document.createElement('span');
            el.className = 'hlth-contact-attach__file';
            var sizeKB = (e.size / 1024).toFixed(0);
            el.innerHTML = e.name + ' <span style="opacity:0.4">(' + sizeKB + ' KB)</span> <button type="button" class="hlth-contact-attach__remove" data-idx="' + i + '">&times;</button>';
            fileList.appendChild(el);
          });
          fileList.querySelectorAll('.hlth-contact-attach__remove').forEach(function(btn) {
            btn.addEventListener('click', function(ev) {
              ev.stopPropagation();
              removeFile(parseInt(btn.dataset.idx));
            });
          });
        }

        function syncHidden() {
          /* Remove any previously injected hidden fields */
          section.querySelectorAll('[data-hlth-attachment-field]').forEach(function(el) { el.remove(); });
          var form = section.querySelector('form');
          if (!form || !entries.length) { fileData.value = ''; return; }
          var names = [];
          entries.forEach(function(e, i) {
            names.push(e.name + ' (' + (e.size / 1024).toFixed(0) + ' KB)');
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'contact[Attachment_' + (i + 1) + ']';
            hidden.value = e.name + '||' + e.dataUrl;
            hidden.setAttribute('data-hlth-attachment-field', '');
            form.appendChild(hidden);
          });
          fileData.value = names.join(', ');
        }
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-contact')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-contact').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_contact) return;
      w.__hlthJs_hlth_contact = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
